import resetSelectedOriginsOperation from 'state/selectOrigins/operations/resetSelectedOriginsOperation';
import resetSelectedDestinationsOperation from 'state/selectDestinations/operations/resetSelectedDestinationsOperation';
import updateSelectedDestinations from 'state/selectDestinations/operations/updateSelectedDestinations';
import resetCalendarDatesOp from 'state/selectDates/operations/resetCalendarDatesOp';
import resetSelectedRooms from 'state/selectRooms/operations/resetSelectedRooms';
import { fetchSearchResults } from '../actions';

export default function updateDestinationAndFetchSearchResults(destination) {
  return (dispatch) => {
    dispatch(resetSelectedOriginsOperation());
    dispatch(resetSelectedDestinationsOperation());
    dispatch(resetCalendarDatesOp());
    dispatch(resetSelectedRooms());
    dispatch(updateSelectedDestinations([destination]));
    dispatch(fetchSearchResults());
  };
}
